var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVet3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150.000000pt",
    height: "150.000000pt",
    viewBox: "0 0 150.000000 150.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,150.000000) scale(0.100000,-0.100000)",
    fill: "#D00202",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1142 1388 c-24 -24 -10 -45 93 -148 58 -58 105 -108 105 -112 0 -5 -294 -8 -654 -8 -582 0 -656 -2 -670 -16 -19 -19 -20 -36 -4 -52 9 -9 172 -12 670 -12 362 0 658 -3 658 -8 0 -4 -47 -54 -105 -112 -58 -58 -105 -112 -105 -122 0 -19 26 -48 43 -48 16 0 327 312 327 329 0 8 -68 83 -152 168 -151 152 -177 170 -206 141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 593 c-87 -86 -158 -164 -158 -172 0 -24 301 -321 325 -321 25 0 45 18 45 40 0 8 -47 62 -105 120 -58 58 -105 108 -105 112 0 5 294 8 654 8 582 0 656 2 670 16 19 19 20 36 4 52 -9 9 -172 12 -670 12 -362 0 -658 3 -658 8 0 4 47 54 105 112 58 58 105 112 105 122 0 19 -26 48 -43 48 -6 0 -82 -71 -169 -157z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVet3);
export default __webpack_public_path__ + "static/media/vet-3.f2e4cb19817a25f3e9fe7f6bc47528d2.svg";
export { ForwardRef as ReactComponent };